import { FormControl, Input, InputLabel } from "@mui/material";
import { useFormContext } from "react-hook-form";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";

const Index = ({ nazivPolja, disabled }: any) => {
  const { register } = useFormContext();
  return (
    <FormControl fullWidth error={!daLiJePoljeValidno(nazivPolja)}>
      <InputLabel id={`${nazivPolja}`}>
        *Identifikacijski broj (Identification number)
      </InputLabel>
      <Input {...register(nazivPolja)} disabled={disabled} />
      <PorukaGreskePolja nazivPolja={nazivPolja} />
    </FormControl>
  );
};

export default Index;
